import { render, staticRenderFns } from "./DialogBaseSkeleton.vue?vue&type=template&id=2914f042"
import script from "./DialogBaseSkeleton.vue?vue&type=script&lang=ts"
export * from "./DialogBaseSkeleton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports